export const DETAIL_VIEW_TABS = [
  {
    key: "fleet",
    label: "Vue flotte",
    panelId: "fleet-view",
  },
  {
    key: "suspended",
    label: "Suspendues",
    panelId: "suspended-center",
  },
  {
    key: "warnings",
    label: "Avertissements",
    panelId: "warnings-center",
  },
  {
    key: "errors",
    label: "Alertes",
    panelId: "errors-center",
  },
];

export function getDetailViewLabel(activeView = "") {
  const matchingTab = DETAIL_VIEW_TABS.find((tab) => tab.key === activeView);
  return matchingTab ? matchingTab.label : "Aucune vue ouverte";
}

export function getDetailViewPanelId(viewName = "") {
  const matchingTab = DETAIL_VIEW_TABS.find((tab) => tab.key === viewName);
  return matchingTab ? matchingTab.panelId : "";
}

export function getDetailViewFromHash(hash = "") {
  const normalizedHash = typeof hash === "string" ? hash.replace(/^#/, "") : "";
  if (!normalizedHash) {
    return null;
  }

  const matchingTab = DETAIL_VIEW_TABS.find((tab) => tab.panelId === normalizedHash);
  return matchingTab ? matchingTab.key : null;
}